import { observable } from 'mobx';
import BasePollableLoginStore, { Service } from './BasePollableLoginStore';
import RootStore from './RootStore';

export interface SmartIdLoginCredentials {
  personalCode: string;
  countryCode: string;
}

export enum CountryCode {
  EE = 'EE',
  LV = 'LV',
  LT = 'LT',
}

export default class SmartIdLoginStore extends BasePollableLoginStore {
  @observable accessor smartIdLoginCredentials: SmartIdLoginCredentials = {
    personalCode: '',
    countryCode: CountryCode.EE,
  };

  constructor(props: RootStore) {
    super(props);
  }

  get loginCredentials(): SmartIdLoginCredentials {
    return this.smartIdLoginCredentials;
  }

  get service(): Service {
    return 'smart-id';
  }
}
